
export default {
  // TODO: data도 props 추가해야함.
  props: { theadList: Array, tdList: Array, renderItem: Array },
  data() {
    return {
      renderItemCount: this.renderItem && this.renderItem.length,
      RenderList: [],
    }
  },

  computed: {
    getNewList() {
      this.selectionItem()

      return this.RenderList
    },
  },

  methods: {
    selectionItem() {
      let index = 0

      for (let i = 0; i < this.tdList.length; i++) {
        this.RenderList.push([])
        for (let j = 0; j < this.renderItemCount; j++) {
          this.RenderList[index].push(this.tdList[i][this.renderItem[j]])
        }
        index++
      }

      console.log(this.RenderList)
    },
  },
}
